//
import axios from 'axios'
import EmployeeModel from "@/models/HumanResource/HrEmployee"
import { getFetchDataFunction } from '../DataTableService'

/**
 * 
 */
const create = async data => {

    //
    try {

        //
        const response = await ( new EmployeeModel( data ) ).save()

        //
        return response
    } catch ( error ) {

        //
        return error.response
    }
}

/**
 * 
 */
const fetchAll = async () => {

    //
    try {

        //
        const response = await EmployeeModel.append( appends ).include( includes ).params({ get_all_results: true }).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const fetchById = async id => {

    //
    try {

        //
        const response = await EmployeeModel.append( appends ).include( includes ).find( id )

        //
        return response
    } catch ( error ) {

        //
        return error.response
    }
}

/**
 * 
 */
const generateUserAccount = async ( id, data ) => {

    //
    console.log({ id, data })

    //
    try {

        //
        const response = await axios.post( process.env.VUE_APP_API_ROUTE + '/hr_employee/' + id + '/user_account', data )

        //
        return response.data
    } catch ( error ) {

        //
        console.log({ error })

        //
        return error.response.data
    }
}

/**
 * 
 */
const remove = async id => {
    try {

        //
        const response = await axios.delete( process.env.VUE_APP_API_ROUTE + '/hr_employee/' + id )
        
        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const update = async ( id, data ) => {
    try {

        //
        const response = await axios.patch( process.env.VUE_APP_API_ROUTE + '/hr_employee/' + id, data )
        
        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

const fetchByRut = async (rut) => {
    try {
        //
        const route     = process.env.VUE_APP_API_ROUTE.concat( '/hr_employee?filter[rut]='+rut )
        const response  = await axios.get( route )
        //
        return response.data.data
    } catch (error) {
        //
        return error.response.data
    }
}

const updateApv = async (data) => {
    try {
        //
        const response = await axios.post( process.env.VUE_APP_API_ROUTE + '/hr_employee_apv/upsert', data )
        //
        return response.data
    } catch ( error ) {
        //
        return error.response.data
    }
}

const updateIps = async (data) => {
    try {
        //
        const response = await axios.post( process.env.VUE_APP_API_ROUTE + '/hr_employee_ips/upsert', data )
        //
        return response.data
    } catch ( error ) {
        //
        return error.response.data
    }
}

const remunerations = async (idEmployee) =>{
    const url = process.env.VUE_APP_API_ROUTE.concat(
        `/hr_salary_settlement?filter[hr_employee_id]=${idEmployee}`
    )
    try {
        //
        const response = await axios.get(url)
        //
        return response.data
    } catch ( error ) {
        //
        return error.response.data
    }
}
/**
 * 
 */
const appends = [
    'discount',
]

/**
 * 
 */
const includes = [
    'hr_prevision',
    'active_contract.hr_contract_type',
    'active_contract.hr_contract_period',
    //'active_contract.hr_contract_asset_discount.hr_asset_discount',
    'active_contract.hr_contract_asset_discount.hr_asset_discount.hr_asset_discount_type',
    'hr_family_burdens',
    'hr_isapre_plans.hr_isapre_type',
    'hr_isapre_plan_active.hr_isapre_type',
    'all_contract',
    'active_contract',
    'hr_previred_nationality',
    'hr_previred_employee_type',
    'hr_employee_apv.hr_previred_apv',
    'hr_employee_apv.hr_previred_apv_payment_type',
    'hr_employee_ips.hr_previred_ips', 

]

//
export default {
    create,
    dtFetchData: getFetchDataFunction( process.env.VUE_APP_API_ROUTE + '/hr_employee', includes, appends ),
    fetchAll,
    fetchById,
    generateUserAccount,
    remove,
    update,
    fetchByRut,
    updateApv,
    updateIps,
    remunerations,
}
